module.exports = __webpack_public_path__ + "img/avatar0.92971d40.png";